/* Arche Mariage v5 : micro-interactions globales (chargé en defer sur toutes les pages).
   - apparition au défilement des éléments [data-am-reveal] (IntersectionObserver, une seule fois) ;
   - boutons magnétiques [data-am-magnetic] (pointeur fin, survol réel, déplacement de 6 px au plus) ;
   - entrée douce de la page après une navigation InstantClick ;
   - mouvement réduit : rien ne bouge, tout est visible.
   Écouteurs délégués posés une seule fois, compatibles avec InstantClick et l'éditeur de thème. */
(function () {
  'use strict';
  if (window.__amMotion) return;
  window.__amMotion = true;

  var root = document.documentElement;
  root.classList.add('am-js', 'am-motion-ok');
  var mqReduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  var mqFine = window.matchMedia ? matchMedia('(hover: hover) and (pointer: fine)') : null;
  function reduced() { return !!(mqReduce && mqReduce.matches); }

  /* ------------------------------------------------------------ apparition */
  var io = null;
  function reveal(el) { el.classList.add('is-in'); }
  function scan(scope) {
    var els = (scope || document).querySelectorAll('[data-am-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduced() || !('IntersectionObserver' in window)) { for (var i = 0; i < els.length; i++) reveal(els[i]); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) { reveal(entries[j].target); io.unobserve(entries[j].target); }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  }
  window.AMReveal = scan;

  /* ------------------------------------------------------------ boutons magnétiques */
  var magEl = null;
  function magReset(el) {
    if (!el) return;
    el.classList.add('is-mag-out');
    el.style.removeProperty('--am-mx');
    el.style.removeProperty('--am-my');
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || reduced() || !(mqFine && mqFine.matches)) return;
    var el = e.target && e.target.closest ? e.target.closest('[data-am-magnetic]') : null;
    if (el !== magEl) { magReset(magEl); magEl = el; }
    if (!el) return;
    var r = el.getBoundingClientRect();
    var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
    var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
    el.classList.remove('is-mag-out');
    el.style.setProperty('--am-mx', (Math.max(-1, Math.min(1, dx)) * 6).toFixed(2) + 'px');
    el.style.setProperty('--am-my', (Math.max(-1, Math.min(1, dy)) * 4).toFixed(2) + 'px');
  }, { passive: true });
  document.addEventListener('pointerleave', function (e) { if (magEl && e.target === magEl) { magReset(magEl); magEl = null; } }, true);

  /* ------------------------------------------------------------ InstantClick : entrée douce */
  function pageEnter() {
    if (reduced() || !document.body) return;
    var b = document.body;
    b.classList.add('am-page-enter');
    setTimeout(function () { b.classList.remove('am-page-enter'); }, 520);
  }

  function init() { scan(document); }
  // Observation lancée quand les feuilles de style des sections sont appliquées (événement load, 1,5 s au plus) :
  // sinon une mise en page encore incomplète ferait « apparaître » d'un coup des éléments situés plus bas.
  var started = false;
  function start() { if (started) return; started = true; init(); }
  if (document.readyState === 'complete') start();
  else {
    window.addEventListener('load', start);
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 1500); });
  }
  if (window.InstantClick && InstantClick.on) InstantClick.on('change', function () { root.classList.add('am-js', 'am-motion-ok'); init(); pageEnter(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  if (mqReduce && mqReduce.addEventListener) mqReduce.addEventListener('change', function () { if (reduced()) scan(document); });
})();
